export enum TransferType {
    Testamentary = "Testamentary",
    Lifetime = "Lifetime"
}

export const fromValue = (poaTypeValue: string) => {
    const matchingEntry = Object.entries(TransferType).find((entry) => {
        return entry[1] === poaTypeValue;
    })
    if(matchingEntry) {
        return matchingEntry[1];
    } else {
        throw new Error("PoaTransferType enum not found for value: " + poaTypeValue);
    }
}